import { makeAutoObservable } from 'mobx';

class TokenStore {
  //测试token
  // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwYThmN2U1OTg1NGI0ZDY0OTk2ZDhmNTUxZWRkNDFlOCJ9.gkDfHZJ7DrMChKOOoh0OmakXirJs9xQ0lLdazQRxOiI";

  token = null;

  constructor() {
    makeAutoObservable(this);
    this.loadToken();
  }

  setToken(token) {
    this.token = token;
    this.saveToken();
  }

  clearToken() {
    this.token = null;
    this.removeToken();
  }

  saveToken() {
    localStorage.setItem('token', this.token);
  }

  loadToken() {
    const token = localStorage.getItem('token');
    if (token) {
      this.token = token;
    }
  }

  removeToken() {
    localStorage.removeItem('token');
  }
}

const tokenStore = new TokenStore();
export default tokenStore;
